import { combineReducers } from 'redux';
import createReducer from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';

const list = createReducer([], {
  [ActionTypes.FETCH_STATES_SUCCESS]: (state, { payload }) => payload
});

const status = createReducer('', {
  [ActionTypes.FETCH_STATES_SUCCESS]: (state, { type }) => type,
  [ActionTypes.FETCH_STATES_ERROR]: (state, { type }) => type
});

export default combineReducers({
  list,
  status
});
